import { isOpenerVariant } from '@game-platform/pack-animation';
import { onOfferOverride } from '../../openingAnimation';
import { preloadOpener } from './loadOpener';

/**
 * A pack with its own library mechanic warms the chunk the moment its payload
 * arrives (pack page, order), as the operator's global one does at boot.
 * Returns the unsubscribe.
 */
export function preloadForPackOverrides(): () => void {
  return onOfferOverride((animation) => {
    if (isOpenerVariant(animation.variant)) preloadOpener();
  });
}
